class CartReco extends HTMLElement {
  constructor() {
    super();

    // define variables
    this.product_id = this.getAttribute("data-product-id");
    this.cartRecommendationsSection = this.querySelector(".track");
    this.limit = window.innerWidth <= 768 ? 2 : 3;
    // Start functions

    if (this.product_id != "null") {
      this.fetchReco(parseInt(this.product_id), 3);
    }
  }

  insertRecommendation = (recommendation, variantId) => {
    // Créer un conteneur div pour le HTML de la recommandation
    const container = document.createElement("div");
    container.classList.add("recommendation");
    container.innerHTML = `
    
      <a href="${recommendation.url}" class="recommendation__image">
        <img src="${recommendation.images[0]}" alt="${recommendation.title}">
      </a>
      <div class="recommendation-info">
        <a href="${
          recommendation.url
        }" class="mini-cart__product-title text--strong link">${
      recommendation.title
    }</a>
        <p class="price">${(recommendation.price / 100).toFixed(2)}€</p>
        <div class="add-to-cart-btn" data-action="add-to-cart" data-product-id="${variantId}">Ajouter</div>
      </div>
    
  `;

    // Le premier élément enfant du conteneur est le HTML structuré que vous voulez retourner
    return container;
  };

  setRecoListeners() {
    setTimeout(() => {
      this.querySelectorAll(".add-to-cart-btn").forEach((button) => {
        button.addEventListener("click", function (e) {
          const originalText = button.innerHTML; // Sauvegarder le texte original du bouton
          button.innerHTML = '<div class="spinner"></div>'; // Mettre le spinner comme contenu du bouton
          button.disabled = true; // Désactiver le bouton

          let productId = button.getAttribute("data-product-id");

          // Supposons que addRecoToCart retourne une Promise
          document
            .querySelector("cart-reco")
            .addRecoToCart(productId, originalText);
        });
      });
    }, 0);
  }

  addRecoToCart(productId, originalText) {
    let quantity = 1; // or any other quantity
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Item added to cart", data);
        document.documentElement.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              quantity: 1,
            },
          })
        );
      })
      .then(() => {
        // Rétablir le texte original et réactiver le bouton une fois que le produit est ajouté
        this.innerHTML = originalText;
        this.disabled = false;
      })
      .then((data) => this.setRecoListeners())

      .catch((error) => {
        console.error("Error:", error);
      });
  }

  fetchReco(productId, limit) {
    console.log("fetchreco");

    fetch(
      `/recommendations/products.json?product_id=${productId}&limit=${limit}`
    )
      .then((response) => response.json())
      .then((data) => {
        const recommendations = data.products;

        if (document.querySelector("cart-reco .track") == null) {
          const newCartRecommendations = document.createElement("div");
          newCartRecommendations.classList.add("cart-recommendations");
          if (window.innerWidth <= 768) {
            // Insérer à la fin de .mini-cart__content pour un appareil mobile
            const miniCartContent = document.querySelector(
              ".mini-cart__content .mini-cart__line-item-list"
            );
            if (miniCartContent != null) {
              miniCartContent.appendChild(newCartRecommendations);
            }
          } else {
            // Insérer au début de .mini-cart__recap pour un appareil non mobile
            const miniCartRecap = document.querySelector(".mini-cart__recap");
            if (miniCartRecap != null) {
              miniCartRecap.insertBefore(
                newCartRecommendations,
                miniCartRecap.firstChild
              );
            }
          }
        }
        document.querySelector("cart-reco .track").innerHTML = "";
        var flkty = new Flickity(document.querySelector("cart-reco .track"), {
          cellAlign: "left",
          contain: true,
          dots: false,
          draggable: true,
        });
        recommendations.forEach((recommendation) => {
          const firstAvailableVariant = recommendation.variants.find(
            (variant) => variant.available === true
          );
          const variantId = firstAvailableVariant
            ? firstAvailableVariant.id
            : null;

          flkty.prepend(
            document
              .querySelector("cart-reco")
              .insertRecommendation(recommendation, variantId)
          );
        });
        flkty.selectCell(0, true, true);
      })
      .then((data) => document.querySelector("cart-reco").setRecoListeners())
      .then((data) => {
        setTimeout(() => {
          var callback = function (mutationsList, observer) {
            var recap = document.querySelector(".mini-cart__recap");
            if (!recap) return; // Ensure the element exists

            var recap_height = recap.clientHeight;
            if (window.innerWidth <= 768) {
              recap_height += 80;
            } else {
            }
            var cart_content = document.querySelector(
              ".mini-cart__line-item-list"
            );
            if (!cart_content) return; // Ensure the element exists

            var newHeight = `calc(100vh - ${recap_height}px)`;
            cart_content.style.height = newHeight;
            cart_content.style.minHeight = newHeight;
            cart_content.style.maxHeight = newHeight;
          };

          // Initialize MutationObserver (example)
          var observer = new MutationObserver(callback);
          var config = { childList: true, subtree: true };
          observer.observe(document.body, config); // Adjust target as necessary
        }, 3000);
      })
      .catch((error) =>
        console.error("Error fetching product recommendations:", error)
      );
  }
}

customElements.define("cart-reco", CartReco);
